import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import pinkyLogo from '../assets/Pinky cloud logo_page-0001.png';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [infoDropdownOpen, setInfoDropdownOpen] = useState(false);
  
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      // Détecte si on est dans la section Hero en scrollant
      const heroSection = document.querySelector('.hero-main, .hero, [class*="hero"]');
      let heroHeight = window.innerHeight; // Par défaut la hauteur de l'écran
      
      if (heroSection) {
        heroHeight = heroSection.offsetHeight;
      }
      
      // Logique corrigée : scrolled = true quand on SORT du Hero
      // scrolled = false quand on est DANS le Hero
      const isOutOfHero = window.scrollY >= heroHeight - 100;
      setScrolled(isOutOfHero);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setInfoDropdownOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setInfoDropdownOpen(false);
  };

  const toggleInfoDropdown = () => {
    setInfoDropdownOpen(!infoDropdownOpen);
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMenu}>
            <div className="logo-icon logo-enlarged">
              <img 
                src={pinkyLogo} 
                alt="Pinky Cloud Logo" 
                className="logo-image"
              />
            </div>
          </Link>

          <ul className="navbar-menu desktop-only">
            <li className="navbar-item">
              <Link
                to="/menu"
                className="navbar-link navbar-button"
                onClick={closeMenu}
              >
                Menu
              </Link>
            </li>
            
            <li className="navbar-item dropdown">
              <button
                onClick={toggleInfoDropdown}
                className="navbar-link navbar-button dropdown-toggle"
              >
                Info
                <ChevronDown size={16} className={`dropdown-icon ${infoDropdownOpen ? 'rotated' : ''}`} />
              </button>
              
              <div className={`dropdown-menu ${infoDropdownOpen ? 'dropdown-open' : ''}`}>
                <Link 
                  to="/contact" 
                  className="dropdown-item"
                  onClick={closeMenu}
                >
                  Contact
                </Link>
                <Link 
                  to="/info" 
                  className="dropdown-item"
                  onClick={closeMenu}
                >
                  Entreprise & Privatisation
                </Link>
                <Link 
                  to="/franchise" 
                  className="dropdown-item"
                  onClick={closeMenu}
                >
                  Franchise
                </Link>
              </div>
            </li>
            
            <li className="navbar-item">
              <Link to="/merch" className="navbar-link merch-link">
                Pinky Merch
              </Link>
            </li>
          </ul>

          <button
            className={`mobile-menu-toggle mobile-only ${isOpen ? 'menu-open' : 'menu-closed'}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className={`mobile-menu ${isOpen ? 'mobile-menu-open' : ''}`}>
            <ul className="mobile-menu-list">
              <li>
                <Link
                  to="/menu"
                  className="mobile-menu-link mobile-menu-button"
                  onClick={closeMenu}
                >
                  Menu
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="mobile-menu-link mobile-menu-button"
                  onClick={closeMenu}
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/info"
                  className="mobile-menu-link mobile-menu-button"
                  onClick={closeMenu}
                >
                  Entreprise & Privatisation
                </Link>
              </li>
              <li>
                <Link 
                  to="/franchise" 
                  className={`mobile-menu-link ${location.pathname === '/franchise' ? 'active' : ''}`} 
                  onClick={closeMenu}
                >
                  Franchise
                </Link>
              </li>
              <li>
                <Link
                  to="/merch"
                  className="mobile-menu-link merch-link"
                  onClick={closeMenu}
                >
                  Pinky Merch
                </Link>
              </li>
            </ul>
          </div>

          {isOpen && <div className="mobile-overlay" onClick={closeMenu}></div>}
        </div>
      </nav>

      
    </>
  );
};

export default Navbar; 